import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileShell from "@/components/MobileShell";
import BottomNav from "@/components/BottomNav";
import api from "@/lib/api";
import { ArrowLeft, ChevronRight } from "lucide-react";

export default function WeeklyProgram() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/dashboard/me").then((r) => {
      if (!r.data?.condition) navigate("/dashboard", { replace: true });
      else setData(r.data);
    });
  }, [navigate]);

  const weeks = data?.condition?.weeks || [];

  return (
    <MobileShell>
      <header className="px-6 pt-8 pb-4">
        <button onClick={() => navigate(-1)} className="text-slate-500 mb-3" data-testid="back-btn"><ArrowLeft size={20} /></button>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600">Weekly program</p>
        <h1 className="text-2xl font-bold font-display text-slate-900 mt-1">Your plan</h1>
      </header>

      <ul className="px-6 space-y-3" data-testid="week-list">
        {weeks.map((w, i) => (
          <li key={i} className="bg-white rounded-2xl border border-slate-100 p-4" data-testid={`week-${i}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="font-semibold text-slate-900 font-display">{w["Week/Module"]}</div>
              <button
                onClick={() => navigate(`/session/${i}/0`)}
                data-testid={`start-week-${i}`}
                className="text-xs font-semibold text-teal-700 inline-flex items-center gap-1"
              >
                Start <ChevronRight size={14} />
              </button>
            </div>
            <Row label="Focus" value={w["Focus"]} />
            <Row label="Lesson" value={w["Education Lesson"]} />
            <Row label="Exercises" value={w["Exercises / Actions"]} />
            <Row label="Check-in" value={w["Check-In Fields"]} />
            <Row label="Progression" value={w["Progression Criteria"]} />
          </li>
        ))}
      </ul>
      <BottomNav />
    </MobileShell>
  );
}

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div className="mt-2">
      <div className="text-[10px] uppercase tracking-[0.15em] text-slate-500 font-bold">{label}</div>
      <div className="text-sm text-slate-700 mt-0.5 leading-relaxed">{value}</div>
    </div>
  );
}
